export class ClientSchemaValidationError extends Error {
  public readonly IsExpectedError: boolean = true;
}
